import { Grid, Switch } from "@material-ui/core";
import { SwitchesFormControlLabel } from "../styles/styles";

const SwitchesContainer = ({
  label = "",
  value = false,
  setValue = () => {},
  disabled = false,
}) => (
  <Grid item key={label}>
    <SwitchesFormControlLabel
      disabled={disabled}
      value="end"
      control={
        <Switch
          checked={value}
          onChange={() => setValue((current) => !current)}
          color="primary"
        />
      }
      label={label}
      labelPlacement="end"
    />
  </Grid>
);
export default SwitchesContainer;
